import { InjectionToken, Provider, Type } from '@angular/core';
// import type { TourAnchorDirective } from 'ngx-ui-tour-core';
// import { TOUR_ANCHOR_DIRECTIVE_TYPE } from '../../app/directives/tout-anchour.directive'; // or your own file if customized

// export function provideTourDirective<T extends TourAnchorDirective>(anchorDirectiveType: Type<T>): Provider {
//   return {
//     provide: TOUR_ANCHOR_DIRECTIVE_TYPE,
//     useValue: anchorDirectiveType
//   };
// }

export const DELAY_AFTER_NAVIGATION = new InjectionToken<number>('DelayAfterNavigation', {
  factory: () => 0
});
